import * as React from "react";
import {useEffect, useState} from "react";
import {makeStyles, Spinner, Tree, TreeItem, TreeItemLayout} from "@fluentui/react-components";
import {insertText} from "../../taskpane";
import {useChampsFusionService} from "../../../utils/services/http.service";
import {DocumentModel} from "../../../utils/models/document.model";

export interface ChampsFusionProps {
    document: DocumentModel;
}

const useStyles = makeStyles({
    page: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        rowGap: "8px",
    },
    arbre: {
        overflow: "auto",
        maxHeight: "min(350px, 50vh)",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        borderTopWidth: "1px",
        borderRightWidth: "1px",
        borderBottomWidth: "1px",
        borderLeftWidth: "1px",
        borderTopStyle: "solid",
        borderRightStyle: "solid",
        borderBottomStyle: "solid",
        borderLeftStyle: "solid",
        borderTopColor: "#8a8886",
        borderRightColor: "#8a8886",
        borderBottomColor: "#8a8886",
        borderLeftColor: "#8a8886",
        borderRadius: "5px",
    },
});

const ChampsFusion: React.FC<ChampsFusionProps> = (props: ChampsFusionProps) => {
    const styles = useStyles();
    const [data, setData] = useState([]);
    const [progress, setProgress] = useState(false);

    const champsFusionService = useChampsFusionService();

    useEffect(() => {
        setProgress(true);
        chargerChampsFusion().then(() => setProgress(false));
    }, [props.document?.Type]);

    async function chargerChampsFusion() {
        let champsFusion = await champsFusionService.champsFusion(props.document?.Type);
        setData(champsFusion?.listeForJson || []);
    }

    function addField(node): any {
        let rubrique = "";
        if (node.IdWordChampChapitre !== "FACTURE") {
            rubrique = `{${node.IdWordChampChapitre}}.`;
        }
        let chapitre = node.IdWordChampsRubrique?.startsWith("ChampPerso")
            ? `${node.IdWordChampsRubrique}:${node.ValeurWordChampRubrique.replace("*", " ")}`
            : node.IdWordChampsRubrique;
        insertText(`${rubrique}{${chapitre}}`);
    }

    const texteChamp = {
        whiteSpace: "normal" as const,
        overflowWrap: "anywhere" as const,
        textOverflow: "unset" as const,
        minWidth: 0,
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: "auto",
    };

    return (
        <div className={styles.page}>
            {progress && <Spinner size="small"/>}
            <div className={styles.arbre}>
                <Tree aria-label="Champs de fusion">
                    {Array.isArray(data) && data.map((rubrique) => (
                        <TreeItem itemType="branch" key={rubrique.IdWordChampChapitre}>
                            <TreeItemLayout main={{style: texteChamp}}>{rubrique.ValeurWordChampChapitre}</TreeItemLayout>
                            <Tree>
                                {Array.isArray(rubrique.rubrique) && rubrique.rubrique.map((champ) => (
                                    <TreeItem itemType="leaf" key={champ.IdWordChampsRubrique}>
                                        <TreeItemLayout
                                            main={{style: texteChamp}}
                                            onClick={() => addField(champ)}>{champ.ValeurWordChampRubrique}</TreeItemLayout>
                                    </TreeItem>
                                ))}
                            </Tree>
                        </TreeItem>
                    ))}
                </Tree>
            </div>
        </div>
    );
};

export default ChampsFusion;
